import { MuiTelInput, MuiTelInputProps } from 'mui-tel-input';

export { type TextFieldProps } from '@mui/material';

import { blue, red, slate, white } from '@/lib/colours';
import { Skeleton } from '../Skeleton';

type MuiPhoneInput = MuiTelInputProps & {
  loading?: boolean;
};

export function MuiPhoneInput(props: MuiPhoneInput) {
  const { loading = false } = props;

  if (loading) {
    return <Skeleton variant="text" />;
  }

  if (props.variant === 'filled') {
    return (
      <MuiTelInput
        {...props}
        InputLabelProps={{
          shrink: true,
          ...props.InputLabelProps,
          sx: {
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: '500',
            lineHeight: '20px',
            letterSpacing: '0.25px',
            paddingTop: '3px',
            paddingLeft: '1px',
            ...props.InputLabelProps?.sx,
          },
        }}
        InputProps={{
          disableUnderline: true,
          ...props.InputProps,
          sx: {
            backgroundColor: white[900],
            borderRadius: '8px',
            border: `1px solid ${slate[300]}`,
            ':focus-within': {
              borderColor: slate[300],
            },
            ':has(input[aria-invalid="true"])': {
              borderColor: red[600],
            },
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: '20px',
            letterSpacing: '0.25px',
            '&.Mui-disabled': {
              borderRadius: '8px',
              fontStyle: 'italic',
            },
            ...props.InputProps?.sx,
          },
        }}
        sx={{
          overflow: 'hidden',
          paddingTop: '1px',
          '.Mui-disabled': {
            '& button': {
              background: 'none',
            },
          },
          ...props.sx,
        }}
      />
    );
  }

  return <MuiTelInput {...props} />;
}
